// Single canonical business entity for John Campbell Insurance.
// Referenced by @id across all pages so search engines treat every page as the
// SAME organization (no duplicate/conflicting entities).
// PRIVACY: intentionally NO PostalAddress and NO geo coordinates — John's
// address is private. areaServed is by city/state/country only.

export const SITE = "https://johncampbellinsurance.com";
export const ORG_ID = `${SITE}/#organization`;

export const businessEntity = {
  "@context": "https://schema.org",
  "@type": ["InsuranceAgency", "LocalBusiness"],
  "@id": ORG_ID,
  name: "John Campbell Insurance",
  url: SITE,
  telephone: "+1-623-414-1766",
  email: "John@johncampbellinsurance.com",
  logo: `${SITE}/logo-crest.png`,
  image: `${SITE}/og-image.png`,
  description:
    "Independent life insurance broker helping individuals and families in Chandler, throughout Arizona, and in select states understand their options through clear, relationship-first guidance.",
  // areaServed = the 10 states where JCI currently holds an active license.
  // Chandler is the highlighted AZ city. Do NOT add the whole US, CA, NY, or
  // prospective future-license states.
  areaServed: [
    { "@type": "City", name: "Chandler", containedInPlace: { "@type": "State", name: "Arizona" } },
    { "@type": "State", name: "Arizona" },
    { "@type": "State", name: "Colorado" },
    { "@type": "State", name: "Oregon" },
    { "@type": "State", name: "New Mexico" },
    { "@type": "State", name: "Texas" },
    { "@type": "State", name: "Florida" },
    { "@type": "State", name: "South Carolina" },
    { "@type": "State", name: "Massachusetts" },
    { "@type": "State", name: "Hawaii" },
    { "@type": "State", name: "Ohio" },
  ],
  knowsAbout: [
    "Life Insurance",
    "Term Life Insurance",
    "Whole Life Insurance",
    "Universal Life Insurance",
    "Indexed Universal Life Insurance",
    "Mortgage Protection Insurance",
    "Final Expense Insurance",
    "Annuities",
    "Retirement Planning",
  ],
  sameAs: ["https://hihello.com/hi/johnacampbellivarizona"],
};

// Lightweight reference used inside other schema (e.g. Service.provider).
export const orgRef = { "@id": ORG_ID };
